<template> 
  <b-modal :id="id" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
    <template #modal-header="{ ok }">
      <slot name="header"></slot>
      <button type="button" class="close" @click="handleOk(ok)">×</button>
    </template>

    <template #default="{ ok }">
      <slot name="content" :close="ok" :changed="didChange"></slot>
    </template>
  </b-modal>
</template>

<script>
  export default {
    props: ['id'],

    data() {
      return {
        changed: false
      }
    },

    methods: {
      didChange() {
        this.changed = true
      },

      handleOk(ok) {
        if (this.changed) {
          if (window.confirm('You have unsaved changes - are you sure?')) {
            ok.call(this);
          }
        } else {
          ok.call(this);
        }
      }
    }
  }
</script>

<style scoped>
  .close {
    padding: 1rem;
    margin: -1rem;

    border: none;
  }
</style>